import { render, staticRenderFns } from "./GestionDocumentos.vue?vue&type=template&id=31808ec3&scoped=true"
import script from "./GestionDocumentos.vue?vue&type=script&lang=js"
export * from "./GestionDocumentos.vue?vue&type=script&lang=js"
import style0 from "./GestionDocumentos.vue?vue&type=style&index=0&id=31808ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31808ec3",
  null
  
)

export default component.exports